import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';

export const subscribeToTaskSource = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .onSnapshot(
      (doc) => onUpdate(doc.data()?.isPrimaryTaskSource || 'prodaff'),
      (err) => {
        console.error('Task source listener error:', err);
        onUpdate('prodaff');
      }
    );
};

export const getJiraAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/jiraGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectJira = async (companyId, userId) => {
  const { data } = await httpClient.post('/jiraDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getJiraProjects = async (companyId) => {
  const { data } = await httpClient.post('/jiraGetProjects', { companyId });
  return data;
};

export const saveJiraSelectedProjects = async (companyId, projects) => {
  const { data } = await httpClient.post('/jiraSaveSelectedProjects', {
    companyId,
    projects,
  });
  return data;
};

export const importJiraTasks = async (companyId) => {
  const { data } = await httpClient.post('/jiraImportTasks', { companyId });
  return data;
};

export const subscribeToJiraStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('jira')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            cloudId: null,
            siteName: null,
            siteUrl: null,
            selectedProjects: [],
            importStatus: null,
            lastImportAt: null,
            lastImportStats: null,
            connectedAt: null,
            connectedBy: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          cloudId: d.cloudId || null,
          siteName: d.siteName || null,
          siteUrl: d.siteUrl || null,
          selectedProjects: d.selectedProjects || [],
          importStatus: d.importStatus || null,
          lastImportAt: d.lastImportAt?.toDate?.() ?? null,
          lastImportStats: d.lastImportStats || null,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
        });
      },
      (err) => {
        console.error('Jira status listener error:', err);
        onUpdate({
          connected: false,
          cloudId: null,
          siteName: null,
          siteUrl: null,
          selectedProjects: [],
          importStatus: null,
          lastImportAt: null,
          lastImportStats: null,
          connectedAt: null,
          connectedBy: null,
        });
      }
    );
};
